export default __webpack_public_path__ + "images/CJ.9920c1a.png";